import { useState, useEffect } from 'react';
import toastError from '../../toasts/toastError';

import api from '../../services/api';

const useUsers = () => {
  const [hasMore, setHasMore] = useState(false);
  const [users, setUsers] = useState([]);
  const [count, setCount] = useState(0);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const fetchUsers = async () => {
        try {
          const { data } = await api.get('/users', {
            params: {},
          });
          setUsers(data.users);
          setHasMore(data.hasMore);
          setCount(data.count);
        } catch (err) {
          toastError(err);
        }
      };

      fetchUsers();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, []);

  return { users, hasMore, count };
};

export default useUsers;
